var _defs, _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgHomeAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1329 813",
    width: 1329,
    height: 813,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5245473-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1298.2 814h-1267c-19.61 0-35.5-15.89-35.5-35.5v-741c0-19.61 15.89-35.5 35.5-35.5h1267c19.61 0 35.5 15.89 35.5 35.5v741c0 19.61-15.89 35.5-35.5 35.5z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #aca0f2 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)",
    style: {
      opacity: 0.2
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1448.8 484.1c-33-7.6-66.6-13.3-100.4-16.9-24.1-2.6-48.8-4.1-72.6 0.7-21.4 4.3-41.2 13.5-59.5 24.6-70.5 42.4-121.4 112.1-199.4 141.1-34.5 12.7-72 16.6-107.7 26.1-119.5 32-213.4 133.9-228.8 248.2l768.8 5.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m349.7-97.6c1.7 63.9-27.8 127.6-73.9 159.4-16.4 11.2-34.7 18.9-48.8 33.9-10.9 11.6-18.5 26.9-27 41-46.8 77.5-124.1 124-203.1 134.5-30.9 4.1-63.8 2.6-90.3-16.8l-5.1-349.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1142.5-79.2c-1.1 40.5 17.6 80.9 46.9 101 10.3 7.2 22 12 30.9 21.5 6.9 7.4 11.7 17.1 17.2 26 29.6 49.2 78.6 78.6 128.7 85.3 19.6 2.6 40.5 1.7 57.3-10.7l3.2-221.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m134.3 895.3c1.1-40.5-17.6-81-46.8-101.1-10.4-7.1-22-12-31-21.5-6.9-7.3-11.7-17-17.1-26-29.7-49.1-78.7-78.6-128.8-85.3-19.5-2.6-40.5-1.6-57.3 10.7l-3.2 221.8z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHomeAi);
export default __webpack_public_path__ + "static/media/bg-home-ai.60201cece12e91a5c2fa0568ea3b258c.svg";
export { ForwardRef as ReactComponent };